import { TEN_MIEN_SAPA } from '@sapa/shared'

/** Chữ của tờ "Mã QR mở SAPA" (docs/plans/qr-sapa-va-nut-phan-hoi.md, mục 5.1). */
export const QS = {
  nutMo: 'Mã QR SAPA',
  tieuDe: 'Mã QR mở SAPA',
  goiY: 'Quét bằng camera điện thoại là mở được SAPA. Gửi cho nhân viên mới hoặc tiệm bạn quen.',
  anhMoTa: `Mã QR mở trang ${TEN_MIEN_SAPA}`,
  diaChi: TEN_MIEN_SAPA,
  chiaSe: 'Chia sẻ mã QR',
  taiAnh: 'Tải ảnh mã QR',
  chep: 'Chép đường dẫn',
  daChep: 'Đã chép đường dẫn.',
  chepLoi: 'Chưa chép được. Bạn đọc địa chỉ ở trên cho người cần mở nhé.',
  chiaSeLoi: 'Máy chưa chia sẻ được. Bạn tải ảnh mã QR rồi gửi qua Zalo nhé.',
  chuChiaSe: (url: string) => `Mời bạn dùng SAPA — đặt lịch và quản lý cửa hàng dịch vụ: ${url}`,
  tenTep: 'ma-qr-sapa.png',
  /** Khối QR ở màn Đăng nhập (nhóm B, ADR-114). */
  dnTieuDe: 'Mở SAPA trên điện thoại',
  dnGoiY: 'Đưa camera điện thoại vào mã này là mở được SAPA.',
} as const
